import styled from '@emotion/styled';
import BaseTypography from '@portalterreno/react-ui-core/Typography';

const Typography = styled(BaseTypography)({
  paddingLeft: '13px'
});

export default Typography;
